import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-maritime-950 text-white flex items-center justify-center px-4 py-32 relative overflow-hidden">
      <SEO
        title="404 - Siden blev ikke fundet | JT transportsejlads"
        description="Den side, du leder efter, kunne desværre ikke findes. Gå tilbage til forsiden eller kontakt os for bådtransport på vandet."
      />

      {/* Decorative background nautical compass */}
      <div className="absolute inset-0 flex items-center justify-center opacity-5 pointer-events-none" aria-hidden="true">
        <i className="fa-solid fa-compass text-[32rem]" />
      </div>

      <div className="relative z-10 max-w-lg mx-auto text-center space-y-6">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-cyan-950/80 border border-cyan-500/40 text-cyan-400 text-3xl shadow-inner mx-auto">
          <i className="fa-solid fa-anchor-circle-xmark" aria-hidden="true" />
        </div>

        <span className="text-sm font-bold uppercase tracking-widest text-cyan-400 block">
          Fejlkode 404
        </span>

        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white">
          Siden blev ikke fundet
        </h1>

        <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
          Det ser ud til, at kursen er sat mod ukendt farvand. Siden du leder efter findes desværre ikke eller er blevet flyttet.
        </p>

        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-cyan-600 hover:bg-cyan-500 text-white font-semibold text-sm transition-all shadow-lg"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-white/10 hover:bg-white/15 text-white font-semibold text-sm border border-white/20 transition-all"
          >
            <i className="fa-solid fa-paper-plane text-xs text-cyan-400" aria-hidden="true" />
            <span>Kontakt mig</span>
          </Link>
        </div>

        <div className="pt-6 border-t border-white/10 text-xs text-slate-400">
          Ring gerne direkte på{' '}
          <a href="tel:+4550510062" className="text-cyan-400 font-semibold hover:underline whitespace-nowrap">
            +45 50 51 00 62
          </a>{' '}
          hvis du søger specifik bådtransport.
        </div>
      </div>
    </div>
  );
}
